import { useMemo, useState } from "react";
import { ParamsPanel, validar } from "./ParamsPanel";
import { TablaAmortizacion } from "./TablaAmortizacion";
import { ResumenCards } from "./ResumenCards";
import { fmtMXN, generarTabla, type Params, type Sistema } from "@/lib/amortizacion";

const DEFAULTS: Params = { monto: 50000, tasaMensual: 3.3, cuotas: 6 };

interface Props {
  sistema: Sistema;
  titulo: string;
  descripcion: string;
  formula: string;
  extraLabel: string;
}

export function SimuladorSistema({ sistema, titulo, descripcion, formula, extraLabel }: Props) {
  const [params, setParams] = useState<Params>(DEFAULTS);
  const errores = validar(params);
  const valido = Object.keys(errores).length === 0;
  const tabla = useMemo(
    () => (valido ? generarTabla(sistema, params) : null),
    [sistema, params, valido],
  );

  const extraValor = tabla
    ? sistema === "aleman"
      ? fmtMXN(tabla.periodos[0]!.capital)
      : sistema === "americano"
        ? fmtMXN(tabla.periodos[0]!.interes)
        : fmtMXN(tabla.periodos[0]!.cuota)
    : "—";

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold tracking-tight text-navy sm:text-2xl">{titulo}</h2>
        <p className="mt-1 text-sm text-muted-foreground">{descripcion}</p>
        <p className="mt-2 inline-block rounded-md bg-navy-soft px-2.5 py-1 num text-xs text-navy">
          {formula}
        </p>
      </div>
      <ParamsPanel params={params} onChange={setParams} errores={errores} />
      {tabla ? (
        <>
          <ResumenCards tabla={tabla} extra={{ label: extraLabel, value: extraValor }} />
          <TablaAmortizacion
            tabla={tabla}
            nombre={`amortizacion-${sistema}`}
            conFecha={Boolean(params.primerPago)}
          />
        </>
      ) : (
        <p className="rounded-md border border-destructive/30 bg-destructive/5 px-4 py-3 text-sm text-destructive">
          Corrige los parámetros para generar la tabla de amortización.
        </p>
      )}
    </div>
  );
}
